function findInArray(array, property, value) {
  for (let i = 0; i < array.length; i++) {
    if (array[i] && array[i][property] && array[i][property] == value) {
      return array[i];
    }
  }
}

export { findInArray };
